import {Button, message} from 'antd';
import {v4 as uuid} from 'uuid';
import ResizeWrapper from '@/components/ResizeWrapper';
import BubbleMsg from '@/components/BubbleMsg';
import RippleWave from '@/components/RippleWave';
import {useJoin} from '../../lib/useCommon';
import DouBao from '@/assets/img/user_cyber.png';
import styles from './index.module.less';
import React, {useEffect} from 'react';
import {post} from '@/utils/request';

export interface FormProps {
  username: string;
  roomId: string;
}

export default function () {

  /**
   * 用户点击确认，加入房间
   */
  const [joining, dispatchJoin] = useJoin();
  const handleStart = async (formValues: FormProps) => {
    if (joining) {
      return;
    }
    //处理用户加入房间
    await dispatchJoin(formValues, false);
  };

  const loginAnonymous = () => {
    //用户没有登录，则默认生成一个用户，并使用当前用户自动登录
    post("/ums/web/auth/login/anonymous", {}).then((res) => {
      console.log(res);
      if (res.code === 200) {
        let accessToken = res.data.accessToken;
        let userInfo = res.data;
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        handleStart({
          username: userInfo.userNo,
          roomId: uuid(),
        });
      } else {
        message.error(res.msg);
      }
    })
  };

  const handleExp = () => {
    let accessToken = localStorage.getItem('accessToken');
    let userInfoStr = localStorage.getItem('userInfo');
    if (accessToken === null || accessToken === undefined || userInfoStr === null) {
      console.log("用户未登录")
      loginAnonymous();
    } else {
      //用户已经登录，则生成一个新的房间号码
      console.log("用户已登录")
      let userInfo = JSON.parse(userInfoStr);
      //用户不存在userNo。则需要去除登录状态，重新登录
      if (userInfo.userNo === null || userInfo.userNo === undefined || userInfo.userNo === '') {
        loginAnonymous();
        return;
      }
      handleStart({
        username: userInfo.userNo,
        roomId: uuid(),
      });
    }
  }

  return (
    <ResizeWrapper className={styles.container}>
      <div className={styles['form-wrapper']}>
        <div className={styles.main}>
          <div className={styles.doubao}>
            <RippleWave className={styles.rippleWave}/>
            <BubbleMsg
              className={`${styles.bubble1} ${styles.animatedElement} `}
              text="Friends from afar"
            />
            <BubbleMsg
              className={`${styles.bubble2} ${styles.animatedElement15}`}
              direction="left"
              text="always a pleasure"
            />
            <img src={DouBao} className={styles.doubaoLogo} alt="Logo"/>
            <div className={styles.text}>Engage in conversation with me and embark on a journey of philosophical contemplation!</div>
            <div
              style={{width: '50%', paddingTop: 100}}>
              <Button
                type="primary"
                htmlType="submit"
                size='middle'
                className={styles.startButton}
                onClick={handleExp}
              >
                Experience it now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ResizeWrapper>
  );
}
